// import axios from 'axios';
import cfg from 'common/config';
import $ from "jquery";

function request(url, options) {
    // const method = (options.method || 'get').toUpperCase();
    // const opts = {
    //     url,
    //     method,
    //     baseURL: options.baseUrl || cfg.BASE_URL_PREFIX
    // };
    // let data = options.data || {};
    // method === 'get' ? (opts.params = data) : (opts.data = data);
    // return axios(opts).then(({status, statusText, data}) => {
    //     return data || {};
    // }).catch((err) => {
    //     console.log(err.message);
    //     return {};
    // });
    const method = (options.method || 'get').toUpperCase();
    let data = options.data || {};
    $.ajax({
        type: method,
        async: options.async === false ? false : true,
        data: data,
        url: url.indexOf('//') > -1 ? url : `${options.baseUrl || cfg.BASE_URL_PREFIX}${url}`,
        dataType: "json",
        success: function (res) {
            options.cb && options.cb(res);
            return res
        },
        error: function (err) {
            console.log(err.message);
            return {};
        }
    })
}

export default request;



// WEBPACK FOOTER //
// ./src/common/util/request.js